module.exports = __webpack_public_path__ + "img/home_icon4@2x.187cf0c6.png";